
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604124254166",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "7112",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M788.551 292.895c-74.801 0-135.633-60.832-135.633-135.605V1.119H165.282c-45.595 0-82.548 36.982-82.548 82.549v856.719c0 45.567 36.955 82.493 82.548 82.493h693.46c45.571 0 82.523-36.926 82.523-82.493V292.894H788.551z m16.533 546.221H218.885v-55.301h586.199v55.301z m0-176.966H218.885v-55.301h586.199v55.301z m0-176.966H218.885v-55.301h586.199v55.301z",
        "p-id": "7113"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M706.002 1.119V157.29c0 45.567 36.955 82.493 82.549 82.493h152.714L706.002 1.121z",
        "p-id": "7114"
      }
    }
  ]
})
    }
  